export default __webpack_public_path__ + "static/media/pc-mobile2.d9f74523.png";